
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2838"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2838"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("47uWi", function(module, exports) {

$parcel$export(module.exports, "FlowComponent", () => $2fffd0c62edf8d53$export$608bd20f689d20a6);
class $2fffd0c62edf8d53$export$608bd20f689d20a6 extends HTMLElement {
    _root;
    _bindings = new Map;
    _abort = new AbortController;
    constructor(){
        if (super(), new.target === $2fffd0c62edf8d53$export$608bd20f689d20a6) throw new TypeError("FlowComponent is an abstract class and cannot be instantiated directly.");
        this._root = this.attachShadow({
            mode: "open"
        });
    }
    static get template() {
        return null;
    }
    static get styles() {
        return [];
    }
    static html(t, ...n) {
        let e = "";
        const o = new Set;
        for(let i = 0; i < t.length; i++)if (e += t[i], i < n.length) {
            const d = n[i];
            typeof d == "string" ? (e += `{{${d}}}`, o.add(d)) : e += d;
        }
        const r = document.createElement("div");
        r.innerHTML = e;
        const a = new Map;
        function s(i, d) {
            const g = [];
            let c = i;
            for(; c && c !== d;){
                const h = c.parentNode;
                if (!h) break;
                const f = Array.from(h.childNodes).indexOf(c);
                g.unshift(f), c = h;
            }
            return g;
        }
        function l(i, d) {
            a.has(i) || a.set(i, []), a.get(i).push(d);
        }
        r.querySelectorAll("*").forEach((i)=>{
            const d = s(i, r), g = [];
            Array.from(i.attributes).forEach((c)=>{
                const h = [
                    ...c.value.matchAll(/{{(.*?)}}/g)
                ];
                if (h.length === 0) return;
                const f = [];
                let m = c.value;
                h.forEach((y)=>{
                    const w = y[1].trim();
                    f.push(w), o.add(w), m = m.replace(y[0], "");
                });
                const _ = c.value === `{{${f[0]}}}` && f.length === 1, S = {
                    type: "attr",
                    path: [
                        ...d
                    ],
                    attrName: c.name,
                    template: _ ? null : m,
                    vars: f
                };
                f.forEach((y)=>{
                    l(y, S);
                }), g.push(c.name);
            }), g.forEach((c)=>i.removeAttribute(c));
        });
        const u = document.createTreeWalker(r, NodeFilter.SHOW_TEXT), b = [];
        for(; u.nextNode();){
            const i = u.currentNode;
            i.nodeValue.includes("{{") && b.push(i);
        }
        b.forEach((i)=>{
            const d = i.parentNode, g = i.nodeValue.split(/({{.*?}})/g);
            let c = 0;
            g.forEach((h)=>{
                const f = h.match(/{{(.*?)}}/);
                if (f) {
                    const m = f[1].trim();
                    o.add(m);
                    const _ = document.createTextNode("");
                    d.insertBefore(_, i);
                    const S = s(_, r);
                    l(m, {
                        type: "text",
                        path: [
                            ...S
                        ],
                        varName: m
                    }), c++;
                } else h.length > 0 && (d.insertBefore(document.createTextNode(h), i), c++);
            }), d.removeChild(i);
        });
        const p = document.createElement("template");
        for(; r.firstChild;)p.content.appendChild(r.firstChild);
        return p.vars = [
            ...o
        ], p.bindingMap = a, p;
    }
    static get observedAttributes() {
        const t = this.template;
        return t && t.vars ? t.vars : [];
    }
    connectedCallback() {
        this._abort.signal.aborted && (this._abort = new AbortController);
        const t = this._root.childNodes.length > 0, n = this._bindings.size > 0;
        if (t && n) {
            this.onMount();
            return;
        }
        const e = this.constructor;
        if (t && !n) {
            e.template?.bindingMap && (this._connectBindings(this._root, e.template.bindingMap), e.template.vars && e.template.vars.forEach((a)=>{
                const s = this.getAttribute(a);
                s !== null && this._update(a, s);
            })), this.onMount();
            return;
        }
        const { styles: o, template: r } = e;
        if (o) {
            if (!e._processedStyles) {
                const a = Array.isArray(o) ? o.flat(1 / 0) : [
                    o
                ];
                e._processedStyles = a.map((s)=>{
                    if (s instanceof CSSStyleSheet) return s;
                    if (typeof s == "string") try {
                        const l = new CSSStyleSheet;
                        return l.replaceSync(s), l;
                    } catch  {
                        const u = document.createElement("style");
                        return u.textContent = s, u;
                    }
                    return null;
                }).filter(Boolean);
            }
            e._processedStyles.length && (this._root.adoptedStyleSheets && e._processedStyles[0] instanceof CSSStyleSheet ? this._root.adoptedStyleSheets = e._processedStyles : e._processedStyles.forEach((a)=>{
                a instanceof Node && this._root.appendChild(a.cloneNode(!0));
            }));
        }
        if (r) {
            const a = r.content.cloneNode(!0);
            this._connectBindings(a, r.bindingMap), this._root.appendChild(a);
        }
        this.onMount();
    }
    _connectBindings(t, n) {
        function e(r, a) {
            let s = r;
            for (const l of a)if (s = s.childNodes[l], !s) return null;
            return s;
        }
        const o = new Set;
        n.forEach((r, a)=>{
            r.forEach((s)=>{
                const l = e(t, s.path);
                if (l) {
                    if (s.type === "text") {
                        this._addBinding(a, l);
                        const u = this.getAttribute(a);
                        l.nodeValue = u ?? "";
                    } else if (s.type === "attr") {
                        const u = `${s.path.join(",")}-${s.attrName}`;
                        o.has(u) || (this._addBinding(a, l, s.attrName, s.template, s.vars), this._updateAttribute(l, s.attrName, s.template, s.vars), o.add(u));
                    }
                }
            });
        });
    }
    attributeChangedCallback(t, n, e) {
        n !== e && (this._bindings.has(t) && this._update(t, e), this.onAttributeChanged(t, n, e));
    }
    disconnectedCallback() {
        this._abort.abort(), this._bindings.clear(), this.onUnmount();
    }
    _addBinding(t, n, e = null, o = null, r = null) {
        this._bindings.has(t) || this._bindings.set(t, []), this._bindings.get(t).push({
            target: n,
            prop: e,
            template: o,
            vars: r
        });
    }
    _update(t, n) {
        const e = this._bindings.get(t);
        e && e.forEach((o)=>{
            o.target.nodeType === Node.TEXT_NODE ? o.target.nodeValue = n ?? "" : this._updateAttribute(o.target, o.prop, o.template, o.vars);
        });
    }
    _isDangerousValue(t, n, e) {
        if (![
            "href",
            "src",
            "action",
            "formaction",
            "data",
            "poster",
            "background",
            "style",
            "srcdoc",
            "innerHTML"
        ].includes(t) && !t.startsWith("on") || !n) return !1;
        const o = n.trim(), r = o.toLowerCase();
        if ([
            "javascript:",
            "vbscript:",
            "file:"
        ].some((l)=>r.startsWith(l)) || /&#0*106;&#0*97;&#0*118;/i.test(n) || /\\x6a\\x61\\x76/i.test(n)) return !0;
        if ([
            "href",
            "src",
            "action",
            "formaction",
            "data",
            "poster",
            "background"
        ].includes(t)) {
            if (/^[a-z][a-z0-9+.-]*:/i.test(o) && !/^(https?|mailto|tel|sms|ftp|ftps):/i.test(o)) return !0;
            if (r.startsWith("data:")) return !/^data:image\/(png|jpe?g|gif|webp|svg\+xml);base64,/i.test(o);
        }
        return !!(t === "style" && /expression|javascript|@import|behavior/i.test(n));
    }
    _updateAttribute(t, n, e, o) {
        let r;
        if (e) {
            const l = e.split("");
            r = l.reduce((u, b, p)=>{
                if (p === l.length - 1) return u + b;
                const i = this.getAttribute(o[p]) ?? "";
                return u + b + i;
            }, "").trim();
        } else r = this.getAttribute(o[0]) ?? "";
        if (this._isDangerousValue(n, r, t)) {
            console.warn(`[FlowComponent] Blocked potentially dangerous value for attribute "${n}":`, r);
            return;
        }
        const s = [
            "style",
            "innerHTML",
            "outerHTML",
            "textContent",
            "srcdoc"
        ].includes(n) || n.startsWith("on");
        n in t && !s ? t[n] = r : t.setAttribute(n, r);
    }
    get root() {
        return this._root;
    }
    get signal() {
        return this._abort.signal;
    }
    emit(t, n = {}) {
        this.dispatchEvent(new CustomEvent(t, {
            detail: n,
            bubbles: !0,
            composed: !0
        }));
    }
    onMount() {}
    onUnmount() {}
    onAttributeChanged(t, n, e) {}
}

});

parcelRegister("45f4g", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f935135c761cab4$export$2e2bcd8739ae039);

var $bLN6P = parcelRequire("bLN6P");
const $2f935135c761cab4$var$tailwindSheet = new CSSStyleSheet();
$2f935135c761cab4$var$tailwindSheet.replaceSync($bLN6P.default || $bLN6P);
var $2f935135c761cab4$export$2e2bcd8739ae039 = $2f935135c761cab4$var$tailwindSheet;

});
parcelRegister("bLN6P", function(module, exports) {
module.exports = "/*! tailwindcss v4.2.1 | MIT License | https://tailwindcss.com */\n@layer properties{@supports (((-webkit-hyphens:none)) and (not (margin-trim:inline))) or ((-moz-orient:inline) and (not (color:rgb(from red r g b)))){*,:before,:after,::backdrop{--tw-rotate-x:initial;--tw-rotate-y:initial;--tw-rotate-z:initial;--tw-skew-x:initial;--tw-skew-y:initial;--tw-space-y-reverse:0;--tw-divide-y-reverse:0;--tw-border-style:solid;--tw-font-weight:initial;--tw-tracking:initial;--tw-shadow:0 0 #0000;--tw-shadow-color:initial;--tw-shadow-alpha:100%;--tw-inset-shadow:0 0 #0000;--tw-inset-shadow-color:initial;--tw-inset-shadow-alpha:100%;--tw-ring-color:initial;--tw-ring-shadow:0 0 #0000;--tw-inset-ring-color:initial;--tw-inset-ring-shadow:0 0 #0000;--tw-ring-inset:initial;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-offset-shadow:0 0 #0000;--tw-content:\"\";--tw-translate-x:0;--tw-translate-y:0;--tw-translate-z:0;--tw-duration:initial;--tw-ease:initial}}}@layer theme{:root,:host{--font-sans:ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";--font-mono:ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;--color-red-50:oklch(97.1% .013 17.38);--color-red-100:oklch(93.6% .032 17.717);--color-red-200:oklch(88.5% .062 18.334);--color-red-500:oklch(63.7% .237 25.331);--color-red-600:oklch(57.7% .245 27.325);--color-red-700:oklch(50.5% .213 27.518);--color-red-800:oklch(44.4% .177 26.899);--color-red-900:oklch(39.6% .141 25.723);--color-yellow-100:oklch(97.3% .071 103.193);--color-yellow-800:oklch(47.6% .114 61.907);--color-green-100:oklch(96.2% .044 156.743);--color-green-600:oklch(62.7% .194 149.214);--color-green-800:oklch(44.8% .119 151.328);--color-blue-50:oklch(97% .014 254.604);--color-blue-100:oklch(93.2% .032 255.585);--color-blue-200:oklch(88.2% .059 254.128);--color-blue-500:oklch(62.3% .214 259.815);--color-blue-600:oklch(54.6% .245 262.881);--color-blue-700:oklch(48.8% .243 264.376);--color-blue-800:oklch(42.4% .199 265.638);--color-blue-900:oklch(37.9% .146 265.522);--color-purple-100:oklch(94.6% .033 307.174);--color-purple-800:oklch(43.8% .218 303.724);--color-slate-50:oklch(98.4% .003 247.858);--color-slate-400:oklch(70.4% .04 256.788);--color-slate-700:oklch(37.2% .044 257.287);--color-slate-800:oklch(27.9% .041 260.031);--color-slate-900:oklch(20.8% .042 265.755);--color-gray-50:oklch(98.5% .002 247.839);--color-gray-100:oklch(96.7% .003 264.542);--color-gray-200:oklch(92.8% .006 264.531);--color-gray-300:oklch(87.2% .01 258.338);--color-gray-400:oklch(70.7% .022 261.325);--color-gray-500:oklch(55.1% .027 264.364);--color-gray-600:oklch(44.6% .03 256.802);--color-gray-700:oklch(37.3% .034 259.733);--color-gray-800:oklch(27.8% .033 256.848);--color-gray-900:oklch(21% .034 264.665);--color-black:#000;--color-white:#fff;--spacing:.25rem;--container-md:28rem;--container-6xl:72rem;--text-xs:.75rem;--text-xs--line-height:calc(1 / .75);--text-sm:.875rem;--text-sm--line-height:calc(1.25 / .875);--text-lg:1.125rem;--text-lg--line-height:calc(1.75 / 1.125);--text-xl:1.25rem;--text-xl--line-height:calc(1.75 / 1.25);--text-2xl:1.5rem;--text-2xl--line-height:calc(2 / 1.5);--text-3xl:1.875rem;--text-3xl--line-height:calc(2.25 / 1.875);--text-4xl:2.25rem;--text-4xl--line-height:calc(2.5 / 2.25);--font-weight-medium:500;--font-weight-semibold:600;--font-weight-bold:700;--tracking-tight:-.025em;--tracking-widest:.1em;--radius-md:.375rem;--radius-lg:.5rem;--radius-xl:.75rem;--radius-2xl:1rem;--radius-3xl:1.5rem;--ease-in-out:cubic-bezier(.4, 0, .2, 1);--animate-spin:spin 1s linear infinite;--animate-pulse:pulse 2s cubic-bezier(.4, 0, .6, 1) infinite;--default-transition-duration:.15s;--default-transition-timing-function:cubic-bezier(.4, 0, .2, 1);--default-font-family:var(--font-sans);--default-mono-font-family:var(--font-mono)}}@layer base{*,:after,:before,::backdrop{box-sizing:border-box;border:0 solid;margin:0;padding:0}::file-selector-button{box-sizing:border-box;border:0 solid;margin:0;padding:0}html,:host{-webkit-text-size-adjust:100%;tab-size:4;line-height:1.5;font-family:var(--default-font-family,ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\");font-feature-settings:var(--default-font-feature-settings,normal);font-variation-settings:var(--default-font-variation-settings,normal);-webkit-tap-highlight-color:transparent}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:var(--default-mono-font-family,ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace);font-feature-settings:var(--default-mono-font-feature-settings,normal);font-variation-settings:var(--default-mono-font-variation-settings,normal);font-size:1em}small{font-size:80%}sub,sup{vertical-align:baseline;font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}:-moz-focusring{outline:auto}progress{vertical-align:baseline}summary{display:list-item}ol,ul,menu{list-style:none}img,svg,video,canvas,audio,iframe,embed,object{vertical-align:middle;display:block}img,video{max-width:100%;height:auto}button,input,select,optgroup,textarea{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}::file-selector-button{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}:where(select:is([multiple],[size])) optgroup{font-weight:bolder}:where(select:is([multiple],[size])) optgroup option{padding-inline-start:20px}::file-selector-button{margin-inline-end:4px}::placeholder{opacity:1}@supports (not ((-webkit-appearance:-apple-pay-button))) or (contain-intrinsic-size:1px){::placeholder{color:currentColor}@supports (color:color-mix(in lab, red, red)){::placeholder{color:color-mix(in oklab, currentcolor 50%, transparent)}}}textarea{resize:vertical}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-date-and-time-value{min-height:1lh;text-align:inherit}::-webkit-datetime-edit{display:inline-flex}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-datetime-edit{padding-block:0}::-webkit-datetime-edit-year-field{padding-block:0}::-webkit-datetime-edit-month-field{padding-block:0}::-webkit-datetime-edit-day-field{padding-block:0}::-webkit-datetime-edit-hour-field{padding-block:0}::-webkit-datetime-edit-minute-field{padding-block:0}::-webkit-datetime-edit-second-field{padding-block:0}::-webkit-datetime-edit-millisecond-field{padding-block:0}::-webkit-datetime-edit-meridiem-field{padding-block:0}::-webkit-calendar-picker-indicator{line-height:1}:-moz-ui-invalid{box-shadow:none}button,input:where([type=button],[type=reset],[type=submit]){appearance:button}::file-selector-button{appearance:button}::-webkit-inner-spin-button{height:auto}::-webkit-outer-spin-button{height:auto}[hidden]:where(:not([hidden=until-found])){display:none!important}}@layer components{.toggle-track{cursor:pointer;align-items:center;display:inline-flex;position:relative}.toggle-input{clip-path:inset(50%);white-space:nowrap;border-width:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}.toggle-slider{height:calc(var(--spacing) * 6);width:calc(var(--spacing) * 11);background-color:var(--color-gray-200);transition-property:color,background-color,border-color,outline-color,text-decoration-color,fill,stroke,--tw-gradient-from,--tw-gradient-via,--tw-gradient-to;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration));--tw-duration:.2s;--tw-ease:var(--ease-in-out);transition-duration:.2s;transition-timing-function:var(--ease-in-out);border-radius:3.40282e38px;position:relative}.toggle-input:checked+.toggle-slider{background-color:var(--color-blue-600)}.toggle-input:focus+.toggle-slider{--tw-ring-shadow:var(--tw-ring-inset, ) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color,currentcolor);box-shadow:var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);--tw-ring-color:var(--color-blue-100);--tw-outline-style:none;outline-style:none}.toggle-slider:after{content:\"\";height:calc(var(--spacing) * 5);width:calc(var(--spacing) * 5);border-style:var(--tw-border-style);border-width:1px;border-color:var(--color-gray-300);background-color:var(--color-white);transition-property:transform,translate,scale,rotate;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration));--tw-duration:.2s;--tw-ease:var(--ease-in-out);transition-duration:.2s;transition-timing-function:var(--ease-in-out);border-radius:3.40282e38px;position:absolute;top:2px;left:2px}.toggle-input:checked+.toggle-slider:after{--tw-translate-x:100%;translate:var(--tw-translate-x) var(--tw-translate-y);border-color:var(--color-white)}.toggle-label{margin-left:calc(var(--spacing) * 2);font-size:var(--text-sm);line-height:var(--tw-leading,var(--text-sm--line-height));color:var(--color-gray-700)}}@layer utilities{.pointer-events-auto{pointer-events:auto}.pointer-events-none{pointer-events:none}.sr-only{clip-path:inset(50%);white-space:nowrap;border-width:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}.fixed{position:fixed}.relative{position:relative}.static{position:static}.inset-0{inset:calc(var(--spacing) * 0)}.top-4{top:calc(var(--spacing) * 4)}.right-4{right:calc(var(--spacing) * 4)}.z-50{z-index:50}.container{width:100%}@media (width>=40rem){.container{max-width:40rem}}@media (width>=48rem){.container{max-width:48rem}}@media (width>=64rem){.container{max-width:64rem}}@media (width>=80rem){.container{max-width:80rem}}@media (width>=96rem){.container{max-width:96rem}}.mx-4{margin-inline:calc(var(--spacing) * 4)}.mt-2{margin-top:calc(var(--spacing) * 2)}.mt-4{margin-top:calc(var(--spacing) * 4)}.mr-2{margin-right:calc(var(--spacing) * 2)}.mb-1{margin-bottom:calc(var(--spacing) * 1)}.mb-2{margin-bottom:calc(var(--spacing) * 2)}.mb-3{margin-bottom:calc(var(--spacing) * 3)}.mb-4{margin-bottom:calc(var(--spacing) * 4)}.mb-6{margin-bottom:calc(var(--spacing) * 6)}.mb-10{margin-bottom:calc(var(--spacing) * 10)}.ml-1{margin-left:calc(var(--spacing) * 1)}.ml-2{margin-left:calc(var(--spacing) * 2)}.block{display:block}.flex{display:flex}.grid{display:grid}.hidden{display:none}.inline-flex{display:inline-flex}.h-2{height:calc(var(--spacing) * 2)}.h-3{height:calc(var(--spacing) * 3)}.h-5{height:calc(var(--spacing) * 5)}.h-6{height:calc(var(--spacing) * 6)}.h-8{height:calc(var(--spacing) * 8)}.h-10{height:calc(var(--spacing) * 10)}.h-16{height:calc(var(--spacing) * 16)}.h-20{height:calc(var(--spacing) * 20)}.h-full{height:100%}.h-screen{height:100vh}.min-h-screen{min-height:100vh}.w-2{width:calc(var(--spacing) * 2)}.w-3{width:calc(var(--spacing) * 3)}.w-5{width:calc(var(--spacing) * 5)}.w-8{width:calc(var(--spacing) * 8)}.w-10{width:calc(var(--spacing) * 10)}.w-11{width:calc(var(--spacing) * 11)}.w-20{width:calc(var(--spacing) * 20)}.w-24{width:calc(var(--spacing) * 24)}.w-64{width:calc(var(--spacing) * 64)}.w-fit{width:fit-content}.w-full{width:100%}.max-w-6xl{max-width:var(--container-6xl)}.max-w-md{max-width:var(--container-md)}.min-w-\\[300px\\]{min-width:300px}.flex-1{flex:1}.-rotate-12{rotate:-12deg}.rotate-12{rotate:12deg}.transform{transform:var(--tw-rotate-x, ) var(--tw-rotate-y, ) var(--tw-rotate-z, ) var(--tw-skew-x, ) var(--tw-skew-y, )}.animate-pulse{animation:var(--animate-pulse)}.animate-spin{animation:var(--animate-spin)}.cursor-not-allowed{cursor:not-allowed}.cursor-pointer{cursor:pointer}.grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.flex-col{flex-direction:column}.items-center{align-items:center}.items-end{align-items:flex-end}.items-start{align-items:flex-start}.justify-between{justify-content:space-between}.justify-center{justify-content:center}.justify-end{justify-content:flex-end}.gap-1{gap:calc(var(--spacing) * 1)}.gap-2{gap:calc(var(--spacing) * 2)}.gap-3{gap:calc(var(--spacing) * 3)}.gap-4{gap:calc(var(--spacing) * 4)}.gap-6{gap:calc(var(--spacing) * 6)}:where(.space-y-1>:not(:last-child)){--tw-space-y-reverse:0;margin-block-start:calc(calc(var(--spacing) * 1) * var(--tw-space-y-reverse));margin-block-end:calc(calc(var(--spacing) * 1) * calc(1 - var(--tw-space-y-reverse)))}:where(.space-y-2>:not(:last-child)){--tw-space-y-reverse:0;margin-block-start:calc(calc(var(--spacing) * 2) * var(--tw-space-y-reverse));margin-block-end:calc(calc(var(--spacing) * 2) * calc(1 - var(--tw-space-y-reverse)))}:where(.space-y-4>:not(:last-child)){--tw-space-y-reverse:0;margin-block-start:calc(calc(var(--spacing) * 4) * var(--tw-space-y-reverse));margin-block-end:calc(calc(var(--spacing) * 4) * calc(1 - var(--tw-space-y-reverse)))}:where(.space-y-6>:not(:last-child)){--tw-space-y-reverse:0;margin-block-start:calc(calc(var(--spacing) * 6) * var(--tw-space-y-reverse));margin-block-end:calc(calc(var(--spacing) * 6) * calc(1 - var(--tw-space-y-reverse)))}:where(.space-y-8>:not(:last-child)){--tw-space-y-reverse:0;margin-block-start:calc(calc(var(--spacing) * 8) * var(--tw-space-y-reverse));margin-block-end:calc(calc(var(--spacing) * 8) * calc(1 - var(--tw-space-y-reverse)))}:where(.divide-y>:not(:last-child)){--tw-divide-y-reverse:0;border-bottom-style:var(--tw-border-style);border-top-style:var(--tw-border-style);border-top-width:calc(1px * var(--tw-divide-y-reverse));border-bottom-width:calc(1px * calc(1 - var(--tw-divide-y-reverse)))}:where(.divide-gray-100>:not(:last-child)){border-color:var(--color-gray-100)}.overflow-hidden{overflow:hidden}.overflow-x-auto{overflow-x:auto}.overflow-y-auto{overflow-y:auto}.rounded{border-radius:.25rem}.rounded-2xl{border-radius:var(--radius-2xl)}.rounded-3xl{border-radius:var(--radius-3xl)}.rounded-\\[2rem\\]{border-radius:2rem}.rounded-full{border-radius:3.40282e38px}.rounded-lg{border-radius:var(--radius-lg)}.rounded-md{border-radius:var(--radius-md)}.rounded-none{border-radius:0}.rounded-xl{border-radius:var(--radius-xl)}.rounded-tl-lg{border-top-left-radius:var(--radius-lg)}.rounded-tr-lg{border-top-right-radius:var(--radius-lg)}.border{border-style:var(--tw-border-style);border-width:1px}.border-2{border-style:var(--tw-border-style);border-width:2px}.border-t{border-top-style:var(--tw-border-style);border-top-width:1px}.border-b{border-bottom-style:var(--tw-border-style);border-bottom-width:1px}.border-l-4{border-left-style:var(--tw-border-style);border-left-width:4px}.border-gray-100{border-color:var(--color-gray-100)}.border-gray-200{border-color:var(--color-gray-200)}.border-gray-300{border-color:var(--color-gray-300)}.border-gray-700{border-color:var(--color-gray-700)}.border-red-200{border-color:var(--color-red-200)}.border-slate-800{border-color:var(--color-slate-800)}.border-transparent{border-color:#0000}.border-white{border-color:var(--color-white)}.bg-black\\/50{background-color:#00000080}@supports (color:color-mix(in lab, red, red)){.bg-black\\/50{background-color:color-mix(in oklab, var(--color-black) 50%, transparent)}}.bg-blue-50{background-color:var(--color-blue-50)}.bg-blue-100{background-color:var(--color-blue-100)}.bg-blue-500{background-color:var(--color-blue-500)}.bg-blue-600{background-color:var(--color-blue-600)}.bg-blue-800{background-color:var(--color-blue-800)}.bg-gray-50{background-color:var(--color-gray-50)}.bg-gray-50\\/50{background-color:#f9fafb80}@supports (color:color-mix(in lab, red, red)){.bg-gray-50\\/50{background-color:color-mix(in oklab, var(--color-gray-50) 50%, transparent)}}.bg-gray-100{background-color:var(--color-gray-100)}.bg-gray-200{background-color:var(--color-gray-200)}.bg-gray-700{background-color:var(--color-gray-700)}.bg-green-100{background-color:var(--color-green-100)}.bg-purple-100{background-color:var(--color-purple-100)}.bg-red-50{background-color:var(--color-red-50)}.bg-red-100{background-color:var(--color-red-100)}.bg-red-600{background-color:var(--color-red-600)}.bg-red-800{background-color:var(--color-red-800)}.bg-slate-50{background-color:var(--color-slate-50)}.bg-slate-900{background-color:var(--color-slate-900)}.bg-transparent{background-color:#0000}.bg-white{background-color:var(--color-white)}.bg-yellow-100{background-color:var(--color-yellow-100)}.p-2{padding:calc(var(--spacing) * 2)}.p-3{padding:calc(var(--spacing) * 3)}.p-4{padding:calc(var(--spacing) * 4)}.p-6{padding:calc(var(--spacing) * 6)}.p-8{padding:calc(var(--spacing) * 8)}.p-10{padding:calc(var(--spacing) * 10)}.px-2{padding-inline:calc(var(--spacing) * 2)}.px-3{padding-inline:calc(var(--spacing) * 3)}.px-4{padding-inline:calc(var(--spacing) * 4)}.px-6{padding-inline:calc(var(--spacing) * 6)}.px-8{padding-inline:calc(var(--spacing) * 8)}.py-0\\.5{padding-block:calc(var(--spacing) * .5)}.py-1{padding-block:calc(var(--spacing) * 1)}.py-2{padding-block:calc(var(--spacing) * 2)}.py-3{padding-block:calc(var(--spacing) * 3)}.py-4{padding-block:calc(var(--spacing) * 4)}.py-5{padding-block:calc(var(--spacing) * 5)}.py-8{padding-block:calc(var(--spacing) * 8)}.pt-3{padding-top:calc(var(--spacing) * 3)}.pt-4{padding-top:calc(var(--spacing) * 4)}.pt-6{padding-top:calc(var(--spacing) * 6)}.pl-4{padding-left:calc(var(--spacing) * 4)}.text-center{text-align:center}.text-left{text-align:left}.text-right{text-align:right}.font-sans{font-family:var(--font-sans)}.text-2xl{font-size:var(--text-2xl);line-height:var(--tw-leading,var(--text-2xl--line-height))}.text-3xl{font-size:var(--text-3xl);line-height:var(--tw-leading,var(--text-3xl--line-height))}.text-4xl{font-size:var(--text-4xl);line-height:var(--tw-leading,var(--text-4xl--line-height))}.text-lg{font-size:var(--text-lg);line-height:var(--tw-leading,var(--text-lg--line-height))}.text-sm{font-size:var(--text-sm);line-height:var(--tw-leading,var(--text-sm--line-height))}.text-xl{font-size:var(--text-xl);line-height:var(--tw-leading,var(--text-xl--line-height))}.text-xs{font-size:var(--text-xs);line-height:var(--tw-leading,var(--text-xs--line-height))}.font-bold{--tw-font-weight:var(--font-weight-bold);font-weight:var(--font-weight-bold)}.font-medium{--tw-font-weight:var(--font-weight-medium);font-weight:var(--font-weight-medium)}.font-semibold{--tw-font-weight:var(--font-weight-semibold);font-weight:var(--font-weight-semibold)}.tracking-tight{--tw-tracking:var(--tracking-tight);letter-spacing:var(--tracking-tight)}.tracking-widest{--tw-tracking:var(--tracking-widest);letter-spacing:var(--tracking-widest)}.whitespace-nowrap{white-space:nowrap}.text-blue-600{color:var(--color-blue-600)}.text-blue-700{color:var(--color-blue-700)}.text-blue-800{color:var(--color-blue-800)}.text-gray-300{color:var(--color-gray-300)}.text-gray-400{color:var(--color-gray-400)}.text-gray-500{color:var(--color-gray-500)}.text-gray-600{color:var(--color-gray-600)}.text-gray-700{color:var(--color-gray-700)}.text-gray-800{color:var(--color-gray-800)}.text-gray-900{color:var(--color-gray-900)}.text-green-600{color:var(--color-green-600)}.text-green-800{color:var(--color-green-800)}.text-purple-800{color:var(--color-purple-800)}.text-red-600{color:var(--color-red-600)}.text-red-800{color:var(--color-red-800)}.text-slate-400{color:var(--color-slate-400)}.text-slate-700{color:var(--color-slate-700)}.text-slate-800{color:var(--color-slate-800)}.text-white{color:var(--color-white)}.text-yellow-800{color:var(--color-yellow-800)}.uppercase{text-transform:uppercase}.opacity-25{opacity:.25}.opacity-50{opacity:.5}.opacity-75{opacity:.75}.shadow-2xl{--tw-shadow:0 25px 50px -12px var(--tw-shadow-color,#00000040);box-shadow:var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)}.shadow-lg{--tw-shadow:0 10px 15px -3px var(--tw-shadow-color,#0000001a), 0 4px 6px -4px var(--tw-shadow-color,#0000001a);box-shadow:var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)}.shadow-md{--tw-shadow:0 4px 6px -1px var(--tw-shadow-color,#0000001a), 0 2px 4px -2px var(--tw-shadow-color,#0000001a);box-shadow:var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)}.shadow-sm{--tw-shadow:0 1px 3px 0 var(--tw-shadow-color,#0000001a), 0 1px 2px -1px var(--tw-shadow-color,#0000001a);box-shadow:var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)}.shadow-xl{--tw-shadow:0 20px 25px -5px var(--tw-shadow-color,#0000001a), 0 8px 10px -6px var(--tw-shadow-color,#0000001a);box-shadow:var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)}.shadow-blue-500\\/30{--tw-shadow-color:#3080ff4d}@supports (color:color-mix(in lab, red, red)){.shadow-blue-500\\/30{--tw-shadow-color:color-mix(in oklab, color-mix(in oklab, var(--color-blue-500) 30%, transparent) var(--tw-shadow-alpha), transparent)}}.shadow-red-500\\/30{--tw-shadow-color:#fb2c364d}@supports (color:color-mix(in lab, red, red)){.shadow-red-500\\/30{--tw-shadow-color:color-mix(in oklab, color-mix(in oklab, var(--color-red-500) 30%, transparent) var(--tw-shadow-alpha), transparent)}}.transition-all{transition-property:all;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.transition-colors{transition-property:color,background-color,border-color,outline-color,text-decoration-color,fill,stroke,--tw-gradient-from,--tw-gradient-via,--tw-gradient-to;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.outline-none{--tw-outline-style:none;outline-style:none}.peer-checked\\:bg-blue-600:is(:where(.peer):checked~*){background-color:var(--color-blue-600)}.peer-focus\\:ring-4:is(:where(.peer):focus~*){--tw-ring-shadow:var(--tw-ring-inset, ) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color,currentcolor);box-shadow:var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)}.peer-focus\\:ring-blue-100:is(:where(.peer):focus~*){--tw-ring-color:var(--color-blue-100)}.peer-focus\\:outline-none:is(:where(.peer):focus~*){--tw-outline-style:none;outline-style:none}.after\\:absolute:after{content:var(--tw-content);position:absolute}.after\\:top-\\[2px\\]:after{content:var(--tw-content);top:2px}.after\\:left-\\[2px\\]:after{content:var(--tw-content);left:2px}.after\\:h-5:after{content:var(--tw-content);height:calc(var(--spacing) * 5)}.after\\:w-5:after{content:var(--tw-content);width:calc(var(--spacing) * 5)}.after\\:rounded-full:after{content:var(--tw-content);border-radius:3.40282e38px}.after\\:border:after{content:var(--tw-content);border-style:var(--tw-border-style);border-width:1px}.after\\:border-gray-300:after{content:var(--tw-content);border-color:var(--color-gray-300)}.after\\:bg-white:after{content:var(--tw-content);background-color:var(--color-white)}.after\\:transition-all:after{content:var(--tw-content);transition-property:all;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.after\\:content-\\[\\'\\'\\]:after{--tw-content:\"\";content:var(--tw-content)}.peer-checked\\:after\\:translate-x-full:is(:where(.peer):checked~*):after{content:var(--tw-content);--tw-translate-x:100%;translate:var(--tw-translate-x) var(--tw-translate-y)}.peer-checked\\:after\\:border-white:is(:where(.peer):checked~*):after{content:var(--tw-content);border-color:var(--color-white)}@media (hover:hover){.hover\\:bg-blue-50:hover{background-color:var(--color-blue-50)}.hover\\:bg-blue-200:hover{background-color:var(--color-blue-200)}.hover\\:bg-blue-700:hover{background-color:var(--color-blue-700)}.hover\\:bg-blue-900:hover{background-color:var(--color-blue-900)}.hover\\:bg-gray-50:hover{background-color:var(--color-gray-50)}.hover\\:bg-gray-100:hover{background-color:var(--color-gray-100)}.hover\\:bg-gray-200:hover{background-color:var(--color-gray-200)}.hover\\:bg-gray-300:hover{background-color:var(--color-gray-300)}.hover\\:bg-gray-800:hover{background-color:var(--color-gray-800)}.hover\\:bg-red-50:hover{background-color:var(--color-red-50)}.hover\\:bg-red-200:hover{background-color:var(--color-red-200)}.hover\\:bg-red-700:hover{background-color:var(--color-red-700)}.hover\\:bg-red-900:hover{background-color:var(--color-red-900)}.hover\\:bg-slate-800:hover{background-color:var(--color-slate-800)}.hover\\:text-blue-800:hover{color:var(--color-blue-800)}.hover\\:text-gray-600:hover{color:var(--color-gray-600)}.hover\\:text-red-800:hover{color:var(--color-red-800)}.hover\\:text-white:hover{color:var(--color-white)}}.focus\\:border-blue-500:focus{border-color:var(--color-blue-500)}.focus\\:bg-white:focus{background-color:var(--color-white)}.focus\\:ring-2:focus{--tw-ring-shadow:var(--tw-ring-inset, ) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color,currentcolor);box-shadow:var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow)}.focus\\:ring-blue-500:focus{--tw-ring-color:var(--color-blue-500)}.focus\\:ring-gray-500:focus{--tw-ring-color:var(--color-gray-500)}.focus\\:ring-red-500:focus{--tw-ring-color:var(--color-red-500)}.focus\\:ring-offset-2:focus{--tw-ring-offset-width:2px;--tw-ring-offset-shadow:var(--tw-ring-inset, ) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)}.focus\\:outline-none:focus{--tw-outline-style:none;outline-style:none}@media (width>=48rem){.md\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.md\\:grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}}@media (width>=64rem){.lg\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.lg\\:grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}}}:root{--primary:#3b82f6;--bg-gray:#f9fafb}body{-webkit-font-smoothing:antialiased;margin:0;padding:0}*{box-sizing:border-box}@keyframes fadeIn{0%{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}.animate-fade-in{animation:.4s ease-out forwards fadeIn}::-webkit-scrollbar{width:6px;height:6px}::-webkit-scrollbar-track{background:0 0}::-webkit-scrollbar-thumb{background:#cbd5e1;border-radius:10px}::-webkit-scrollbar-thumb:hover{background:#94a3b8}@property --tw-rotate-x{syntax:\"*\";inherits:false}@property --tw-rotate-y{syntax:\"*\";inherits:false}@property --tw-rotate-z{syntax:\"*\";inherits:false}@property --tw-skew-x{syntax:\"*\";inherits:false}@property --tw-skew-y{syntax:\"*\";inherits:false}@property --tw-space-y-reverse{syntax:\"*\";inherits:false;initial-value:0}@property --tw-divide-y-reverse{syntax:\"*\";inherits:false;initial-value:0}@property --tw-border-style{syntax:\"*\";inherits:false;initial-value:solid}@property --tw-font-weight{syntax:\"*\";inherits:false}@property --tw-tracking{syntax:\"*\";inherits:false}@property --tw-shadow{syntax:\"*\";inherits:false;initial-value:0 0 #0000}@property --tw-shadow-color{syntax:\"*\";inherits:false}@property --tw-shadow-alpha{syntax:\"<percentage>\";inherits:false;initial-value:100%}@property --tw-inset-shadow{syntax:\"*\";inherits:false;initial-value:0 0 #0000}@property --tw-inset-shadow-color{syntax:\"*\";inherits:false}@property --tw-inset-shadow-alpha{syntax:\"<percentage>\";inherits:false;initial-value:100%}@property --tw-ring-color{syntax:\"*\";inherits:false}@property --tw-ring-shadow{syntax:\"*\";inherits:false;initial-value:0 0 #0000}@property --tw-inset-ring-color{syntax:\"*\";inherits:false}@property --tw-inset-ring-shadow{syntax:\"*\";inherits:false;initial-value:0 0 #0000}@property --tw-ring-inset{syntax:\"*\";inherits:false}@property --tw-ring-offset-width{syntax:\"<length>\";inherits:false;initial-value:0}@property --tw-ring-offset-color{syntax:\"*\";inherits:false;initial-value:#fff}@property --tw-ring-offset-shadow{syntax:\"*\";inherits:false;initial-value:0 0 #0000}@property --tw-content{syntax:\"*\";inherits:false;initial-value:\"\"}@property --tw-translate-x{syntax:\"*\";inherits:false;initial-value:0}@property --tw-translate-y{syntax:\"*\";inherits:false;initial-value:0}@property --tw-translate-z{syntax:\"*\";inherits:false;initial-value:0}@property --tw-duration{syntax:\"*\";inherits:false}@property --tw-ease{syntax:\"*\";inherits:false}@keyframes spin{to{transform:rotate(360deg)}}@keyframes pulse{50%{opacity:.5}}";

});


parcelRegister("3mJ7O", function(module, exports) {
module.exports = import("gW6dZ").then(()=>parcelRequire('2darD'));

});

parcelRegister("1PkbG", function(module, exports) {
module.exports = import("fEdSF").then(()=>parcelRequire('allmq'));

});

parcelRegister("hA60b", function(module, exports) {
module.exports = import("kLfKS").then(()=>parcelRequire('6HdQJ'));

});


var $47uWi = parcelRequire("47uWi");

var $45f4g = parcelRequire("45f4g");
class $6e3f07a56e217d45$export$6363f72201106843 {
    #t = new WeakMap;
    #n = new Map;
    constructor(){
        this.plugins = [];
    }
    use(t) {
        return this.plugins.push(t), t(this), this;
    }
    factory(t, e, n = {}) {
        if (typeof t == "string" && n.public) {
            const s = Symbol.for(`helium:public:${t}`);
            return globalThis[s] || (globalThis[s] = this.createChannel(e)), globalThis[s];
        }
        return typeof t == "string" ? (this.#n.has(t) || this.#n.set(t, this.createChannel(e)), this.#n.get(t)) : typeof t == "function" && arguments.length === 1 ? this.action(t) : (typeof t == "object" || typeof t == "function") && t !== null ? Object.getPrototypeOf(t) === Object.prototype && arguments.length === 1 ? this.createChannel(t) : (this.#t.has(t) || this.#t.set(t, this.createChannel(e)), this.#t.get(t)) : this.createChannel(e);
    }
    createChannel(t) {
        const e = new Set;
        return {
            value: t,
            send (n) {
                const s = typeof n == "function" ? n(this.value) : n;
                if (this.value !== s) {
                    this.value = s;
                    for (const i of e)i(s);
                }
            },
            on (n) {
                return e.add(n), n(this.value), ()=>e.delete(n);
            },
            bind (n, s) {
                s(n, this.value);
                const i = (a)=>{
                    if (!n.isConnected) {
                        e.delete(i);
                        return;
                    }
                    s(n, a);
                };
                return e.add(i), ()=>e.delete(i);
            },
            silent (n) {
                this.value = n;
            }
        };
    }
    action(t) {
        const e = this.createChannel({
            data: null,
            loading: !1,
            error: null
        });
        let n = null;
        return e.run = async (...s)=>{
            n && n.abort(), n = new AbortController;
            const { signal: i } = n;
            e.send((a)=>({
                    ...a,
                    loading: !0,
                    error: null
                }));
            try {
                const a = await t({
                    signal: i,
                    args: s
                });
                i.aborted || e.send({
                    data: a,
                    loading: !1,
                    error: null
                });
            } catch (a) {
                !i.aborted && a.name !== "AbortError" && e.send((l)=>({
                        ...l,
                        loading: !1,
                        error: a.message || a
                    }));
            }
        }, e;
    }
}
var $6e3f07a56e217d45$export$2e2bcd8739ae039 = $6e3f07a56e217d45$export$6363f72201106843;


const $9b3e6cedef55f70c$var$cache = new Map();
const $9b3e6cedef55f70c$var$CACHE_TTL = {
    '/api/v1/admin/dashboard/stats': 300000,
    '/api/v1/admin/accounts': 120000,
    '/api/v1/admin/features': 600000
};
function $9b3e6cedef55f70c$var$getCacheKey(endpoint, params) {
    return `${endpoint}?${new URLSearchParams(params || {}).toString()}`;
}
function $9b3e6cedef55f70c$var$getCached(key) {
    const cached = $9b3e6cedef55f70c$var$cache.get(key);
    if (!cached) return null;
    if (Date.now() > cached.expiresAt) {
        $9b3e6cedef55f70c$var$cache.delete(key);
        return null;
    }
    return cached.data;
}
function $9b3e6cedef55f70c$var$setCache(key, data, ttl) {
    $9b3e6cedef55f70c$var$cache.set(key, {
        data: data,
        expiresAt: Date.now() + ttl
    });
}
function $9b3e6cedef55f70c$export$f31942d5b98b6972(pattern) {
    for (const key of $9b3e6cedef55f70c$var$cache.keys())if (key.includes(pattern)) $9b3e6cedef55f70c$var$cache.delete(key);
}
async function $9b3e6cedef55f70c$export$52e83573e7782585(endpoint, options = {}, useCache = false) {
    const token = sessionStorage.getItem('adminToken');
    const cacheKey = $9b3e6cedef55f70c$var$getCacheKey(endpoint, options.params);
    if (useCache && options.method === 'GET') {
        const cached = $9b3e6cedef55f70c$var$getCached(cacheKey);
        if (cached) {
            console.log('[API Cache HIT]', cacheKey);
            return cached;
        }
        console.log('[API Cache MISS]', cacheKey);
    }
    const config = {
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...token && {
                'Authorization': `Bearer ${token}`
            },
            ...options.headers
        }
    };
    const url = `${endpoint}${options.params ? '?' + new URLSearchParams(options.params) : ''}`;
    const response = await fetch(url, config, {
        signal: options.signal
    });
    if (!response.ok) {
        if (response.status === 401) {
            sessionStorage.removeItem('adminToken');
            window.location.reload();
        }
        const error = await response.json().catch(()=>({
                message: 'Request failed'
            }));
        throw new Error(error.message || 'Request failed');
    }
    const data = await response.json();
    if (useCache && options.method === 'GET') {
        const ttl = $9b3e6cedef55f70c$var$CACHE_TTL[endpoint.split('?')[0]] || 60000;
        $9b3e6cedef55f70c$var$setCache(cacheKey, data, ttl);
    }
    return data;
}


function $d38de7c5ea730b66$export$8f30b9a05eb146a5(helium) {
    const sessionChannel = helium.factory('auth:session', null);
    const login = async (email, password, signal)=>{
        const data = await (0, $9b3e6cedef55f70c$export$52e83573e7782585)('/api/v1/auth/login', {
            method: 'POST',
            body: JSON.stringify({
                email: email,
                password: password
            }),
            signal: signal
        });
        // Guardar token ANTES de llamar a /auth/me
        sessionStorage.setItem('adminToken', data.token);
        const user = await (0, $9b3e6cedef55f70c$export$52e83573e7782585)('/api/v1/auth/me', {
            signal: signal
        });
        if (!user?.isSaasAdmin) throw new Error('Acceso denegado: Se requieren privilegios de administrador SaaS');
        sessionChannel.send(()=>user);
        return {
            ...data,
            user: user
        };
    };
    const logout = async (signal)=>{
        try {
            await (0, $9b3e6cedef55f70c$export$52e83573e7782585)('/api/v1/auth/logout', {
                method: 'POST',
                signal: signal
            });
        } catch (error) {
            console.warn('Logout error:', error);
        } finally{
            sessionStorage.removeItem('adminToken');
            sessionChannel.send(()=>null);
        }
    };
    const getCurrentUser = async ()=>{
        const token = sessionStorage.getItem('adminToken');
        if (!token) return null;
        try {
            const user = await (0, $9b3e6cedef55f70c$export$52e83573e7782585)('/api/v1/auth/me');
            if (user?.isSaasAdmin) {
                sessionChannel.send(()=>user);
                return user;
            }
            return null;
        } catch  {
            return null;
        }
    };
    return {
        sessionChannel: sessionChannel,
        login: login,
        logout: logout,
        getCurrentUser: getCurrentUser
    };
}



function $164997d181398534$export$6eb61436bdee25eb(helium) {
    const statsChannel = helium.factory('dashboard:stats', {
        accounts: "\u2014",
        mrr: "\u2014",
        churn: "\u2014",
        active: "\u2014"
    });
    const getStats = async (forceRefresh = false, signal)=>{
        if (!forceRefresh) {
            const cached = await (0, $9b3e6cedef55f70c$export$52e83573e7782585)('/api/v1/admin/dashboard/stats', {
                signal: signal
            }, true);
            if (cached) {
                statsChannel.send(()=>({
                        accounts: cached.totalAccounts.toLocaleString(),
                        mrr: `$${cached.mrr.toLocaleString()}`,
                        churn: cached.churnRate.toFixed(1),
                        active: cached.activeSubscriptions.toLocaleString()
                    }));
                return cached;
            }
        }
        const stats = await (0, $9b3e6cedef55f70c$export$52e83573e7782585)('/api/v1/admin/dashboard/stats', {
            signal: signal
        }, false);
        statsChannel.send(()=>({
                accounts: stats.totalAccounts.toLocaleString(),
                mrr: `$${stats.mrr.toLocaleString()}`,
                churn: stats.churnRate.toFixed(1),
                active: stats.activeSubscriptions.toLocaleString()
            }));
        return stats;
    };
    return {
        statsChannel: statsChannel,
        getStats: getStats
    };
}



function $757dc69f14bf6be4$export$91fe6aebf1af532a(helium) {
    const accountsChannel = helium.factory('accounts:list', {
        data: [],
        pagination: {},
        loading: false
    });
    const filtersChannel = helium.factory('accounts:filters', {
        search: '',
        plan: '',
        status: '',
        page: 1,
        limit: 20,
        sort: 'email',
        order: 'asc'
    });
    const getAll = async (filters = {}, signal)=>{
        const params = {
            ...filters,
            page: filters.page || 1,
            limit: filters.limit || 20
        };
        return await (0, $9b3e6cedef55f70c$export$52e83573e7782585)('/api/v1/admin/accounts', {
            params: params,
            signal: signal
        }, true);
    };
    const getById = async (accountId, signal)=>{
        return await (0, $9b3e6cedef55f70c$export$52e83573e7782585)(`/api/v1/admin/accounts/${accountId}`, {
            signal: signal
        }, true);
    };
    const update = async (accountId, data, signal)=>{
        (0, $9b3e6cedef55f70c$export$f31942d5b98b6972)('/api/v1/admin/accounts');
        return await (0, $9b3e6cedef55f70c$export$52e83573e7782585)(`/api/v1/admin/accounts/${accountId}`, {
            method: 'PATCH',
            body: JSON.stringify(data),
            signal: signal
        });
    };
    const setFilters = (newFilters)=>{
        filtersChannel.send((filters)=>({
                ...filters,
                ...newFilters
            }));
    };
    return {
        accountsChannel: accountsChannel,
        filtersChannel: filtersChannel,
        getAll: getAll,
        getById: getById,
        update: update,
        setFilters: setFilters
    };
}



function $df8cbf416760a533$export$5377b461bd77caf1(helium) {
    const subscriptionsChannel = helium.factory('subscriptions:list', {
        data: [],
        loading: false
    });
    const getAll = async (filters = {}, signal)=>{
        return await (0, $9b3e6cedef55f70c$export$52e83573e7782585)('/api/v1/admin/subscriptions', {
            params: filters,
            signal: signal
        }, true);
    };
    const updateFeatures = async (subscriptionId, featureFlags, signal)=>{
        (0, $9b3e6cedef55f70c$export$f31942d5b98b6972)('/api/v1/admin/subscriptions');
        return await (0, $9b3e6cedef55f70c$export$52e83573e7782585)(`/api/v1/admin/subscriptions/${subscriptionId}`, {
            method: 'PATCH',
            body: JSON.stringify({
                featureFlags: featureFlags
            }),
            signal: signal
        });
    };
    return {
        subscriptionsChannel: subscriptionsChannel,
        getAll: getAll,
        updateFeatures: updateFeatures
    };
}



function $f96cf18356e7c07d$export$93d22f84b9aa2afa(helium) {
    const plansChannel = helium.factory('plans:list', {
        data: [],
        loading: false
    });
    const getAll = async (signal)=>{
        return await (0, $9b3e6cedef55f70c$export$52e83573e7782585)('/api/v1/admin/plans', {
            signal: signal
        }, true);
    };
    const getById = async (planId, signal)=>{
        return await (0, $9b3e6cedef55f70c$export$52e83573e7782585)(`/api/v1/admin/plans/${planId}`, {
            signal: signal
        });
    };
    const create = async (planData, signal)=>{
        (0, $9b3e6cedef55f70c$export$f31942d5b98b6972)('/api/v1/admin/plans');
        return await (0, $9b3e6cedef55f70c$export$52e83573e7782585)('/api/v1/admin/plans', {
            method: 'POST',
            body: JSON.stringify(planData),
            signal: signal
        });
    };
    const update = async (planId, planData, signal)=>{
        (0, $9b3e6cedef55f70c$export$f31942d5b98b6972)('/api/v1/admin/plans');
        return await (0, $9b3e6cedef55f70c$export$52e83573e7782585)(`/api/v1/admin/plans/${planId}`, {
            method: 'PATCH',
            body: JSON.stringify(planData),
            signal: signal
        });
    };
    const remove = async (planId, signal)=>{
        (0, $9b3e6cedef55f70c$export$f31942d5b98b6972)('/api/v1/admin/plans');
        return await (0, $9b3e6cedef55f70c$export$52e83573e7782585)(`/api/v1/admin/plans/${planId}`, {
            method: 'DELETE',
            signal: signal
        });
    };
    return {
        plansChannel: plansChannel,
        getAll: getAll,
        getById: getById,
        create: create,
        update: update,
        remove: remove
    };
}



function $538ed0a439fad3a8$export$ee772b32ba2b3eb1(helium) {
    const featuresChannel = helium.factory('features:flags', {});
    const getFeatures = async (signal)=>{
        const features = await (0, $9b3e6cedef55f70c$export$52e83573e7782585)('/api/v1/admin/features', {
            signal: signal
        }, true);
        featuresChannel.send(()=>features);
        return features;
    };
    const updateFeatures = async (planSlug, features, signal)=>{
        (0, $9b3e6cedef55f70c$export$f31942d5b98b6972)('/api/v1/admin/features');
        const plan = await (0, $9b3e6cedef55f70c$export$52e83573e7782585)('/api/v1/admin/features', {
            method: 'PATCH',
            body: JSON.stringify({
                planSlug: planSlug,
                features: features
            }),
            signal: signal
        });
        featuresChannel.send((current)=>({
                ...current,
                [planSlug]: {
                    name: plan.displayName,
                    features: plan.features
                }
            }));
        return plan;
    };
    return {
        featuresChannel: featuresChannel,
        getFeatures: getFeatures,
        updateFeatures: updateFeatures
    };
}


function $ddd5df2262262e95$export$d4ae7cdcb10ca0a1(helium) {
    const alertsChannel = helium.factory('ui:alerts', []);
    const addAlert = (type, message, duration = 5000)=>{
        const id = Date.now().toString(36) + Math.random().toString(36).substr(2);
        const alert = {
            id: id,
            type: type,
            message: message,
            duration: duration
        };
        alertsChannel.send((alerts)=>[
                ...alerts,
                alert
            ]);
        if (duration > 0) setTimeout(()=>{
            removeAlert(id);
        }, duration);
        return id;
    };
    const removeAlert = (id)=>{
        alertsChannel.send((alerts)=>alerts.filter((a)=>a.id !== id));
    };
    const clearAlerts = ()=>{
        alertsChannel.send(()=>[]);
    };
    const success = (message, duration)=>addAlert('success', message, duration);
    const error = (message, duration)=>addAlert('error', message, duration);
    const warning = (message, duration)=>addAlert('warning', message, duration);
    const info = (message, duration)=>addAlert('info', message, duration);
    return {
        alertsChannel: alertsChannel,
        addAlert: addAlert,
        removeAlert: removeAlert,
        clearAlerts: clearAlerts,
        success: success,
        error: error,
        warning: warning,
        info: info
    };
}


function $dd1d63316f23e351$export$7e8a948cb387023f(helium) {
    const modalsChannel = helium.factory('ui:modals', {
        active: null
    });
    const sidebarChannel = helium.factory('ui:sidebar', {
        collapsed: false
    });
    const openModal = (modalName, data = null)=>{
        modalsChannel.send((modals)=>({
                ...modals,
                active: modalName,
                data: data
            }));
    };
    const closeModal = ()=>{
        modalsChannel.send((modals)=>({
                ...modals,
                active: null,
                data: null
            }));
    };
    const toggleSidebar = ()=>{
        sidebarChannel.send((sidebar)=>({
                ...sidebar,
                collapsed: !sidebar.collapsed
            }));
    };
    return {
        modalsChannel: modalsChannel,
        sidebarChannel: sidebarChannel,
        openModal: openModal,
        closeModal: closeModal,
        toggleSidebar: toggleSidebar
    };
}


const $3a9c63eda2e8ecf0$var$template = (0, $47uWi.FlowComponent).html`<slot></slot>`;



class $3a9c63eda2e8ecf0$export$80cf78d44bd55203 extends (0, $47uWi.FlowComponent) {
    static get template() {
        return $3a9c63eda2e8ecf0$var$template;
    }
    onMount() {
        super.onMount();
        this.root.adoptedStyleSheets = [
            (0, $45f4g.default)
        ];
        this.helium = new (0, $6e3f07a56e217d45$export$2e2bcd8739ae039)();
        this.helium.services = {
            auth: (0, $d38de7c5ea730b66$export$8f30b9a05eb146a5)(this.helium),
            dashboard: (0, $164997d181398534$export$6eb61436bdee25eb)(this.helium),
            accounts: (0, $757dc69f14bf6be4$export$91fe6aebf1af532a)(this.helium),
            subscriptions: (0, $df8cbf416760a533$export$5377b461bd77caf1)(this.helium),
            plans: (0, $f96cf18356e7c07d$export$93d22f84b9aa2afa)(this.helium),
            features: (0, $538ed0a439fad3a8$export$ee772b32ba2b3eb1)(this.helium),
            alerts: (0, $ddd5df2262262e95$export$d4ae7cdcb10ca0a1)(this.helium),
            ui: (0, $dd1d63316f23e351$export$7e8a948cb387023f)(this.helium)
        };
        const sessionChannel = this.helium.factory('auth:session');
        sessionChannel.bind(this, (el, user)=>{
            if (user?.isSaasAdmin) this.navigate('dashboard');
            else this.navigate('login');
        });
        this.#checkAuth();
    }
    async #checkAuth() {
        const token = sessionStorage.getItem('adminToken');
        if (token) try {
            const user = await this.helium.services.auth.getCurrentUser();
            if (user?.isSaasAdmin) return;
        } catch (error) {
            console.warn('Token validation failed:', error);
        }
        sessionStorage.removeItem('adminToken');
        const sessionChannel = this.helium.factory('auth:session');
        sessionChannel.send(()=>null);
    }
    async navigate(view) {
        this.innerHTML = '';
        if (view === 'login') {
            await (parcelRequire("3mJ7O"));
            const login = document.createElement('admin-login');
            login.helium = this.helium;
            this.appendChild(login);
        } else {
            await (parcelRequire("1PkbG"));
            const alerts = document.createElement('admin-alerts');
            alerts.helium = this.helium;
            this.appendChild(alerts);
            await (parcelRequire("hA60b"));
            const layout = document.createElement('admin-layout');
            layout.helium = this.helium;
            this.appendChild(layout);
        }
    }
}
customElements.define('admin-root', $3a9c63eda2e8ecf0$export$80cf78d44bd55203);


console.info('SaaS Admin Panel Initialized');


//# sourceMappingURL=admin.70fff050.js.map
